import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import { Game } from "../Game";
import { GameAssets } from "../GameAssets";
import { ScreenBounds } from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class GameLogo extends PIXI.Container implements StageLayer {

    private _gameLogo: PIXI.Sprite;

    constructor() {
        super();
        this.name = "GameLogo";

        this.init();
        this.onResize();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;

        this._gameLogo.visible = true;
        if (NolimitApplication.isLandscape) {
            if (bounds.width <= 970) {
                this._gameLogo.visible = false;
            }
            this._gameLogo.scale.set(0.5);
            this._gameLogo.position.set(-200, 100);
        } else {
            if (bounds.height <= 970) {
                this._gameLogo.visible = false;
            }
            this._gameLogo.scale.set(1);
            this._gameLogo.position.set(360, -170);
        }
    }

    private init(): void {
        this._gameLogo = new PIXI.Sprite(Game.assetLoader.getTextures(GameAssets.GAME_LOGO)[0]);
        this._gameLogo.anchor.set(0.5);
        this.addChild(this._gameLogo);
    }
}